'use client';

import { usePathname } from 'next/navigation';
import { CSSProperties, ReactNode, useEffect, useRef } from 'react';
import { overlay } from '../overlay.css';
import * as styles from './modal.css';

interface ModalProps {
  children: ReactNode;
  onClose: (isConfirm: boolean) => void;
  containerStyle?: CSSProperties;
  overlayStyle?: CSSProperties;
  shouldCloseOnOverlayClick?: boolean;
  // 모바일 사이즈일 때 full screen을 사용할지 여부
  isMobileFullScreen?: boolean;
}

export function Modal({
  children,
  onClose,
  overlayStyle,
  containerStyle,
  shouldCloseOnOverlayClick = false,
  isMobileFullScreen = false,
}: ModalProps) {
  const pathname = usePathname();
  const pathNameRef = useRef(pathname);

  const handleOverlayClick = () => {
    if (shouldCloseOnOverlayClick) {
      onClose(false);
    }
  };

  useEffect(() => {
    if (pathNameRef.current !== pathname) {
      pathNameRef.current = pathname;
      onClose(false);
    }
  }, [pathname]);

  return (
    <div className={overlay} style={overlayStyle} onClick={handleOverlayClick}>
      <div
        className={styles.modal({ isMobileFullScreen })}
        style={containerStyle}
        onClick={e => e.stopPropagation()}>
        {children}
      </div>
    </div>
  );
}
